// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__Mu-bq","item":"PaymentsMobile_item__2Xdr_","label":"PaymentsMobile_label__1hlaB","amount":"PaymentsMobile_amount__1LXEG"};